import Vue from 'vue'
import VueRouter from 'vue-router'
import {getCache} from "@/utils/useCache";

Vue.use(VueRouter)

const routes = [
    {path: '/', name: 'login', component: () => import('../views/LoginView.vue')},
    {path: '/register', name: 'register', component: () => import('../views/RegisterView.vue')},
    {path: '/forget', name: 'forget', component: () => import('../views/ForgetView.vue')},
    {
        path: '/user', name: 'user', component: () => import('../views/UserLayout.vue'),
        redirect: '/user/home',
        children: [
            {path: '/user/home', component: () => import('../views/user/HomeView.vue')},
            {path: '/user/form', component: () => import('../views/user/FormView.vue')},
            {path: '/user/formu', component: () => import('../views/user/FormuView.vue')},
            {path: '/user/result', component: () => import('../views/user/ResultView.vue')},
            {path: '/user/myself', component: () => import('../views/manage/MyselfView.vue')},
            {path: '/user/record', component: () => import('../views/user/RecordView.vue')},
        ]
    },
    {
        path: '/manage', name: 'manage', component: () => import('../views/ManageLayout.vue'),
        redirect: '/manage/home',
        children: [
            {path: '/manage/home', component: () => import('../views/manage/HomeView.vue')},
            {path: '/manage/user', component: () => import('../views/manage/UserView.vue')},
            {path: '/manage/answer', component: () => import('../views/manage/AnswerView.vue')},
            {path: '/manage/result', component: () => import('../views/manage/ResultView.vue')},
            {path: '/manage/lipid', component: () => import('../views/manage/LipidView.vue')},
            {path: '/manage/myself', component: () => import('../views/manage/MyselfView.vue')},
        ]
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
    const userinfo = getCache('USERINFO')

    if (to.path === '/' || to.path === '/register' || to.path === '/forget') {
        next()
        return
    }

    if (!userinfo) {
        next('/')
        return
    }

    if (to.path.startsWith('/manage') && userinfo.role === 0) {
        next('/user')
        return
    }

    next()
})

export default router
